import type { BaseReactProps, ReactNodeDef } from '@shared/node-v1.0.0'
import { getPortDef, sizes } from '@shared/port-v1.0.0'
import type { Item } from '@shared/types-v0.1.0'

export type Props = BaseReactProps & {
	initialSelected?: string[];
	valuePath: string;
	items?: Item[]
}

import Comp from '../component/SwitchGroup'

export default {
	hashTag: '#pre-release',
	module: { static: Comp },
	inNode: {
		inputs: [
			getPortDef({
				name: 'valuePath',
				displayName: 'Value path',
				group: 'Params',
				type: 'string',
				default: 'id',
				validate: (p: Props) => !!p.valuePath,
			}),
			getPortDef({
				name: 'initialSelected',
				displayName: 'Initial selected',
				group: 'Params',
				type: 'array',
				validate: (p: Props) => {
					if (p.initialSelected?.some((i) => typeof i !== 'string'))
						return `"Initial selected" must be array of string, got: ${JSON.stringify(p.initialSelected)}`
					return true
				},
			}),
			getPortDef({ name: 'label', displayName: 'Label', group: 'Params', type: 'string' }),
			getPortDef({ name: 'description', displayName: 'Description', group: 'Params', type: 'string' }),
			getPortDef({ name: 'error', displayName: 'Error', group: 'Params', type: '*' }),
			getPortDef({ name: 'size', displayName: 'Size', group: 'Dimensions', type: sizes, default: 'sm', tooltip: `<div style='width:200px;'>Параметр влияет на размер текстов в группе, но никак не влияет на дочерние элементы.</div>` }),
			getPortDef({ name: 'withAsterisk', displayName: 'With asterisk', group: 'Styles', type: 'boolean', default: false }),




			getPortDef({
				name: 'items',
				displayName: 'Items',
				group: 'Data',
				type: 'array',
				validate: (p: Props) => !!p.items,
			}),
		],
		outputs: [
			getPortDef({ name: 'selectedValues', displayName: 'Selected values', group: 'Data', type: 'array' }),
			getPortDef({ name: 'selectedItems', displayName: 'Selected items', group: 'Data', type: 'array' }),
			getPortDef({ name: 'changed', displayName: 'Changed', group: 'Signals', type: 'signal' }),
		],
	},
} satisfies ReactNodeDef
